import { Injectable } from "@angular/core";

import { QuotationStates } from "../enums/quotation-states";

import { StatusConfig } from "../models/status-config.model";

@Injectable({
  providedIn: "root",
})
export class QuotationStatusService {
  quotationStatusConfig: Record<string, StatusConfig> = {
    [QuotationStates.Ongoing]: {
      bgClass: "bg-severity-low",

      iconClass: "pi pi-calendar",

      text: "cardStatus.ongoing",
    },

    [QuotationStates.Study]: {
      bgClass: "bg-severity-bronco_gray",

      iconClass: "pi pi-clock",

      text: "cardStatus.study",
    },
    [QuotationStates.ToValidate]: {
      bgClass: "bg-severity-bronco_gray",
      iconClass: "pi pi-clock",
      text: "cardStatus.study",
    },
    [QuotationStates.Expired]: {
      bgClass: "bg-severity-high opacity-50",

      iconClass: "pi pi-calendar-times",

      text: "cardStatus.expired",
    },

    [QuotationStates.ExpireSoon]: {
      bgClass: "bg-golden",

      iconClass: "pi pi-calendar-clock",

      text: "cardStatus.expirationPending",
    },
  };

  constructor() {}

  getStatusConfig() {
    return this.quotationStatusConfig;
  }
}
